/*!
=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================
* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Pagination,
  Col,
  Table,
  OverlayTrigger,
  ControlLabel,
  FormGroup,
  FormControl,
  Modal,
  Tooltip,
} from "react-bootstrap";
import {
  updateOrdersRider,
  GetUserSubscriptionOrderData,
  updatesubscriptionOrderStatus,
  Updatereview,
  getallrider,
  updateOrderStatus,
  searchsubscriptionOrders,
  DeleteSubscriptionOrder,
  DownloadOrder,
  updatepaymentinfo,
  getb2b,
} from "../../../Listfunction";
// react component that creates a switch button that changes from on to off mode
import { Link, withRouter } from "react-router-dom";
import ReactTable from "react-table";
import DatePicker from "react-datepicker";
import Datetime from "react-datetime";
import "react-datepicker/dist/react-datepicker.css";
import Switch from "react-bootstrap-switch";
import SweetAlert from "react-bootstrap-sweetalert";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import Select from "react-select";
import Card from "components/Card/Card.jsx";
import LoadingSpinner from "views/Components/loadingSpinner";
import LoadingPdfSpinner from "views/Components/loadingPdfSpinner";
import Button from "components/CustomButton/CustomButton.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";
import originalMoment from "moment";
import { extendMoment } from "moment-range";
const moment = extendMoment(originalMoment);

export const CheckBox = (props) => {
  return (
    <li>
      <input
        key={props.id}
        onClick={props.handleCheckChieldElement}
        type="checkbox"
        checked={props.isChecked}
        value={props.value}
      />{" "}
      {props.value}
    </li>
  );
};
class subscriptionorderlist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pdfloading: false,
      order_details: [],
      order_chk: [],
      selected_id: [],
      loading: false,
      bulkSelect: null,
      subscriber: "",
      rider_id: "",
      source: "",
      status: "",
      page: "",
      paginationData: [],
      noRecordFound: false,
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      deliveryType: "",
      alert: null,
      viewinvoice: "",
      useraccess: "",
      orderdate: "",
      processing: true,
      channel_filter: "",
      order_id_filter: "",
      fromdate_filter: "",
      todate_filter: "",
      todateerror: null,
      p_orderid: "",
      p_total_cost: "",
      p_paid_amount: "",
      showpaymentdetailmodal: false,
      _notificationSystem: null,
      paymenttype: "",
      f_paymenttype: "",
      remainpaymentamount: "0",
      paidamount: 0,
      errormessages: [],
      cancelorderModal: false,
      ridermodel: false,
      ordercancelreason: "",
      paymentoption: "",
      cancel_reason_display_Modal: false,
      Cancel_reason_state: "",
      ordercancelreasonError: null,
      rider_details: [],
      b2b: "",
      b2bDetails: [],
      rider_info: null,
      rider_infoError: null,
      rider_data: [],
      value: "",
      isdaterangepickerOpen: false,
      rider_details: [],
      time: "",
      order_display_model: false,
      userOrderDetails: [],
      // alert: null,
      fruites: [
        { id: 1, value: "banana", isChecked: false },
        { id: 2, value: "apple", isChecked: false },
        { id: 3, value: "mango", isChecked: false },
        { id: 4, value: "grap", isChecked: false },
      ],
    };
    this.onStatusChange = this.onStatusChange.bind(this);
    this.editOrder = this.editOrder.bind(this);
    this.addorder = this.addorder.bind(this);
    this.searchData = this.searchData.bind(this);
    this.searchdata = this.searchdata.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.onChange = this.onChange.bind(this);
    this.getdata = this.getdata.bind(this);
    this.deleteorderdetails = this.deleteorderdetails.bind(this);
    this.handleUpdateStatus = this.handleUpdateStatus.bind(this);
    this.warningWithConfirmAndCancelMessage =
      this.warningWithConfirmAndCancelMessage.bind(this);
    this.downloadinvoice = this.downloadinvoice.bind(this);
    this.viewpdf = this.viewpdf.bind(this);
    this.onpaymentchange = this.onpaymentchange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.downloadpre = this.downloadpre.bind(this);
    this.oncancelchnage = this.oncancelchnage.bind(this);
    this.openordermodal = this.openordermodal.bind(this);
    this.closeordermodal = this.closeordermodal.bind(this);
  }
  handleDateChange = (date) => {
    this.setState({
      orderdate: date,
    });
  };
  onSelect = (value, states) => {
    this.setState({ value, states });
  };
  onToggle() {
    this.setState({ isdaterangepickerOpen: !this.state.isdaterangepickerOpen });
  }

  open_cancel_reason_display_Modal(cancel_reason) {
    this.setState({
      cancel_reason_display_Modal: true,
      Cancel_reason_state: cancel_reason,
    });
  }
  close_cancel_reason_display_Modal() {
    this.setState({
      cancel_reason_display_Modal: false,
      Cancel_reason_state: "",
    });
  }
  warningWithConfirmAndCancelMessage(id) {
    // alert('hi');
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deleteorderdetails(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this Subscription Order Detail !
        </SweetAlert>
      ),
    });
  }
  downloadpre(url) {
    if (url != "") {
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.setAttribute("download", url);
      // document.body.appendChild(link)
      link.click();
    } else {
      this.setState({
        alert: (
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            <h3>No prescription uploaded!</h3>
          </SweetAlert>
        ),
      });
      // alert("No prescription uploaded")
    }
  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }
  downloadinvoice(id) {
    // const FileDownload = require('js-file-download');
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ pdfloading: true, processing: false }, () => {
      DownloadOrder(id, obj).then((res) => {
        this.setState({ pdfloading: false });
        var ddata = res.data.data.pdf_url;
        // const url = ddata;
        // axio
        // download(ddata.data,file.file_name,content)
        // FileDownload(ddata,'order_'+id+'.pdf')
        // const url = window.URL.createObjectURL(new Blob([res.data]))
        // console.log(url);
        const link = document.createElement("a");
        link.href = ddata;
        link.target = "_blank";
        link.setAttribute("download", "order_" + id + ".pdf");
        // document.body.appendChild(link)
        link.click();
        // this.setState({
        //   viewinvoice : ddata
        // })
        this.setState({ pdfloading: false, processing: true });
      });
    });
  }
  viewpdf(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ pdfloading: true }, () => {
      DownloadOrder(id, obj).then((res) => {
        this.setState({
          //    pdfloading: false,
        });
        var ddata = res.data.data.pdf_url;
        return <a href={ddata} target="_balnk"></a>;
      });
    });
  }
  deleteorderdetails(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    DeleteSubscriptionOrder(id, obj)
      .then((res) => {
        this.setState({
          alert: null,
        });
        this.searchData();
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl");
      });
  }
  getdata(url) {
    this.setState({ page: url });
    this.searchData();
  }
  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    // const value = target.type === 'datetime' ? target.Datetime : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });

    this.searchdata();
  };
  oncancelchnage = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    // const value = target.type === 'datetime' ? target.Datetime : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  };
  onpaymentchange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    // const value = target.type === 'datetime' ? target.Datetime : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
    if (name == "paidamount") {
      var total_amunt = "";
      var paid_amount = "";
      var p_paid_amount = "";
      if (this.state.p_paid_amount == "" || this.state.p_paid_amount == null) {
        p_paid_amount = 0;
      } else {
        p_paid_amount = this.state.p_paid_amount;
      }
      total_amunt =
        parseFloat(this.state.p_total_cost) - parseFloat(p_paid_amount);
      // paid_amount =  parseFloat(value)
      var remain_amount = 0;
      if (value == "") {
        paid_amount = 0;
      } else {
        paid_amount = parseFloat(value);
      }
      remain_amount = parseFloat(total_amunt) - parseFloat(paid_amount);
      remain_amount = remain_amount.toFixed(2);
      this.setState({ remainpaymentamount: remain_amount });
    }
  };
  resetSearch() {
    this.setState({
      subscriber: "",
      source: "",
      status: "",
      rider_id: "",
      orderdate: "",
      b2b: "",
      paymentoption: "",
      order_id_filter: "",
      channel_filter: "",
      fromdate_filter: "",
      todate_filter: "",
      todateerror: null,
      value: "",
      isdaterangepickerOpen: false,
    });
    this.searchData();
  }
  async editOrder(cus, channel) {
    if (channel == "app") {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      // console.log(cus,"<= id || obj =>",obj);
      var review = "1";
      await Updatereview(cus, review, obj).then((res) => {
        console.log(res, "update view order ");
      });
    }
    this.props.history.push("/admin/subscriptionorder/" + cus);
  }
  searchdata(e) {
    this.setState({ page: "", isdaterangepickerOpen: false });
    this.searchData();
  }
  handleUpdateStatus(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    let sts_arr = [];

    if (this.state.bulkSelect != "" && this.state.bulkSelect != null) {
      this.state.order_chk.map((item) => {
        if (item.isChecked) {
          this.state.selected_id.push({ id: item.id });
          sts_arr.push({ id: item.id, status: this.state.bulkSelect });
        }
      });

      // if(this.state.bulkSelect == "6")
      // {
      //    if(this.state.selected_id.length > 0)
      //    {
      //       this.setState({ cancelorderModal : true  });
      //    }else
      //    {
      //       this.setState({
      //          alert: (
      //          <SweetAlert
      //          style={{ display: "block", marginTop: "-100px" }}
      //          title="Please select order!"
      //          onConfirm={() => this.hideAlert()}
      //          onCancel={() => this.hideAlert()}
      //          confirmBtnBsStyle="info"
      //          />
      //          )
      //          });
      //    }

      // }

      // if( this.state.bulkSelect != "6")
      // {
      if (sts_arr.length > 0) {
        updatesubscriptionOrderStatus(sts_arr, obj).then(() => {
          this.searchData();
          this.setState({ selected_id: [] });
        });
      } else {
        this.setState({
          alert: (
            <SweetAlert
              style={{ display: "block", marginTop: "-100px" }}
              title="Please select order!"
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
            />
          ),
        });
      }
      // }
    } else {
      this.setState({
        alert: (
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title="Please select status!"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          />
        ),
      });
    }
  }
  searchData(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var date = "";
    var today = "";
    date = new Date(this.state.orderdate);
    var dd = ("0" + date.getDate()).slice(-2);
    var mm = ("0" + (date.getMonth() + 1)).slice(-2);
    var yyyy = date.getFullYear();
    if (dd != "aN") {
      today = yyyy + "-" + mm + "-" + dd;
    } else {
      today = "";
    }

    var fromdate = "";
    var finalfromdate = "";

    fromdate = new Date(this.state.value.start);
    var fdd = ("0" + fromdate.getDate()).slice(-2);
    var fmm = ("0" + (fromdate.getMonth() + 1)).slice(-2);
    var fyyyy = fromdate.getFullYear();
    if (fdd != "aN") {
      finalfromdate = fyyyy + "-" + fmm + "-" + fdd;
    } else {
      finalfromdate = "";
    }

    var todate = "";
    var todatefinal = "";
    todate = new Date(this.state.value.end);
    var tdd = ("0" + todate.getDate()).slice(-2);
    var tmm = ("0" + (todate.getMonth() + 1)).slice(-2);
    var tyyyy = todate.getFullYear();
    if (tdd != "aN") {
      todatefinal = tyyyy + "-" + tmm + "-" + tdd;
    } else {
      todatefinal = "";
    }

    if (finalfromdate.length != 0) {
      if (todatefinal.length == 0) {
        this.setState({
          todateerror: (
            <small className="text-danger">Todate is required.</small>
          ),
        });
        return;
      } else {
        this.setState({ todateerror: null });
      }
    }

    this.setState({ noRecordFound: false });
    this.setState({ loading: true }, () => {
      searchsubscriptionOrders(this.state.page, obj)
        .then((response) => {
          var data = response.data;
          if (data.data.length == 0) {
            this.setState({ noRecordFound: true });
          }
          var $no_pages = [];
          let serach_url = "";
          let order_chk = [];
          let serach_string = "";
          for (var i = 1; i <= data.last_page; i++) {
            if (serach_string == "") {
              $no_pages.push(i);
            } else {
              $no_pages.push(i);
            }
          }
          if (data.current_page == data.last_page) {
            this.setState({ prevdisabled: null });
            this.setState({ nextdisabled: "1" });
          } else if (data.current_page == 1) {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: "1" });
          } else {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: null });
          }
          if (data.last_page == 1) {
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          if (data.data.length == 0) {
            $no_pages = [];
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          this.setState({ currentPage: data.current_page });
          if (data.next_page_url != null) {
            if (serach_string == "") {
              this.setState({
                nextpage: data.next_page_url.substring(
                  data.next_page_url.indexOf("=") + 1
                ),
              });
            } else {
              this.setState({
                nextpage: data.next_page_url.substring(
                  data.next_page_url.indexOf("=") + 1
                ),
              });
            }
          } else {
            this.setState({ nextpage: "#" });
          }
          if (data.prev_page_url != null) {
            if (serach_string == "") {
              this.setState({
                prevpage: data.prev_page_url.substring(
                  data.prev_page_url.indexOf("=") + 1
                ),
              });
            } else {
              this.setState({
                prevpage: data.prev_page_url.substring(
                  data.prev_page_url.indexOf("=") + 1
                ),
              });
            }
          } else {
            this.setState({ prevpage: "#" });
          }
          this.setState({ paginationData: $no_pages });
          response.data.data.map((ele) => {
            ele["isChecked"] = false;
            order_chk.push(ele);
          });
          this.setState({
            order_details: response.data,
            loading: false,
          });
          console.log(order_chk, "order check");
          this.setState({
            order_chk: order_chk,
          });
        })
        .catch((error) => {
          this.handleNetworkError("bl");
        });
    });
  }
  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }
  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.searchData();

    this.interval = setInterval(() => this.searchData(), 180000);

    this.setState({
      useraccess: token.role,
    });

    getb2b(obj).then((res) => {
      this.setState({ b2bDetails: res.data.data });
    });
    let role = 5;
    getallrider(role, obj).then((res) => {
      const data = res.data;
      var array1 = this.state.rider_details;
      var array2 = array1.concat(data);
      this.setState({
        rider_details: array2,
      });

      let riderItems = [];
      this.state.rider_details.map((x, i) => {
        riderItems.push({ value: x.id, label: x.name });
      });
      this.setState({
        rider_data: riderItems,
      });
    });
  }
  paymentdetail(id, total_cost, paid_amount) {
    this.setState({
      p_total_cost: "",
      remainpaymentamount: "0",
      paymenttype: "",
      paidamount: "0",
    });
    var p_check_a = "";
    if (paid_amount == null) {
      p_check_a = 0;
    } else {
      p_check_a = paid_amount;
    }
    var r_amount = parseFloat(total_cost) - parseFloat(p_check_a);
    r_amount = r_amount.toFixed(2);
    // total_cost = total_cost.toFixed(2);
    this.setState({
      showpaymentdetailmodal: true,
      p_orderid: id,
      p_total_cost: total_cost,
      p_paid_amount: paid_amount,
      remainpaymentamount: r_amount,
    });
  }
  closepaymentdetailmodal() {
    this.setState({ showpaymentdetailmodal: false, errormessages: [] });
  }
  submitpaymentdetail() {
    this.setState({ errormessages: [] });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var total_amunt = "";
    var paid_amount = "";
    if (this.state.paymenttype == "2") {
      total_amunt = this.state.p_total_cost;
      paid_amount = parseFloat(this.state.paidamount);
      paid_amount = paid_amount.toFixed(2);
    } else if (this.state.paymenttype == "1") {
      paid_amount = "0";
    }
    updatepaymentinfo(
      this.state.paymenttype,
      paid_amount,
      this.state.p_orderid,
      obj
    )
      .then((res) => {
        if (res.data.success == true) {
          this.setState({ loading: true });
          this.setState({ showpaymentdetailmodal: false });
          this.componentDidMount();
        } else if (res.data.success == false) {
          if (res.data.data.length != 0) {
            var ermessage = [];
            for (var key of Object.keys(res.data.data)) {
              var data = res.data.data[key];
              ermessage.push(data);
            }
            this.setState({ errormessages: ermessage });
            this.setState({ showpaymentdetailmodal: true });
          } else {
            this.handleClick("bl");
          }
        }
      })
      .catch((res) => {
        console.log(res);
      });
    //   updatepaymentinfo(this.state.paymenttype,paid_amount,this.state.p_orderid,obj)
    //   .then(res => {
    //     console.log(res)
    //     if(res.data.success == true)
    //     {
    //     this.setState({ loading: true });
    //     this.componentDidMount();
    //     }
    //   })
    //   .catch(res => {
    //     console.log(res);
    //   })
    // }
    // this.setState({ showpaymentdetailmodal: false });
  }
  addorder() {
    this.props.history.push("/admin/subscription-add-order");
  }
  handleAllChecked = (event) => {
    let orders_st = this.state.order_chk;
    orders_st.forEach((st) => (st.isChecked = event.target.checked));
    this.setState({ order_chk: orders_st });
  };
  handleCheckChieldElement = (event) => {
    let orders_st = this.state.order_chk;
    orders_st.forEach((st) => {
      if (st.id == event.target.value) {
        st.isChecked = event.target.checked;
      }
    });
    this.setState({ order_chk: orders_st });
  };
  onStatusChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    // const value = target.type === 'datetime' ? target.Datetime : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  };
  openordermodal(id) {
    this.setState({ order_display_model: true });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    GetUserSubscriptionOrderData(id, obj).then((res) => {
      this.setState({ userOrderDetails: res.data.data });
    });
  }
  closeordermodal() {
    this.setState({ userOrderDetails: [], order_display_model: false });
  }
  submitCancelOrderModal() {
    let error = false;
    if (this.state.ordercancelreason.trim() == "") {
      error = true;
      this.setState({
        ordercancelreasonError: (
          <small className="text-danger">Reason is required.</small>
        ),
      });
    } else {
      this.setState({ ordercancelreasonError: null });
    }
    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      let cancel_arr = [];
      let status_chnage = [];
      this.state.selected_id.map((item) => {
        if (item.id != "") {
          status_chnage.push({ id: item.id, status: this.state.bulkSelect });
          // cancel_arr.push({id:item.id ,cancelreason:this.state.ordercancelreason})
        }
      });
      updateOrderStatus(status_chnage, this.state.ordercancelreason, obj).then(
        () => {
          this.searchData();
        }
      );
      this.setState({
        selected_id: [],
        bulkSelect: "",
        ordercancelreason: "",
        ordercancelreasonError: null,
        cancelorderModal: false,
      });
    }
  }
  closeCancelOrderModal() {
    this.setState({
      selected_id: [],
      bulkSelect: "",
      ordercancelreason: "",
      ordercancelreasonError: null,
    });
    this.setState({ cancelorderModal: false });
    this.searchData();
  }
  submitriderdetailsModal() {
    let error = false;
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    if (this.state.rider_info == null) {
      error = true;
      this.setState({
        rider_infoError: (
          <small className="text-danger">Rider is required.</small>
        ),
      });
    } else {
      this.setState({ rider_infoError: null });
    }
    if (!error) {
      let order_id = [];
      this.state.selected_id.map((item) => {
        if (item.id != "") {
          order_id.push(item.id);
        }
      });
      updateOrdersRider(
        order_id,
        this.state.rider_info.value,
        this.state.bulkSelect,
        obj
      ).then((res) => {
        // console.log(res,'add rider');
        this.searchData();
        this.setState({
          selected_id: [],
          ridermodel: false,
          bulkSelect: "",
          rider_info: null,
          rider_infoError: null,
        });
      });
    }
  }
  closeriderdetailsModal() {
    this.setState({
      selected_id: [],
      ridermodel: false,
      bulkSelect: "",
      rider_info: null,
      rider_infoError: null,
    });
    this.searchData();
  }
  render() {
    const view = <Tooltip id="view">View Profile</Tooltip>;
    const edit = <Tooltip id="edit">Edit</Tooltip>;
    const payment = <Tooltip id="payment">Complete Order</Tooltip>;
    const quote = <Tooltip id="quote">Quote</Tooltip>;
    const remove = <Tooltip id="remove">Remove</Tooltip>;
    const errormessages = this.state.errormessages;
    const order_details = this.state.order_details;
    const order_data = this.state.order_chk;

    const order_status_arr = {
      1: "Submitted",
      2: "Schedule Confirmed",
      3: "Lab Team Dispatched",
      4: "Sample Collected",
      5: "Test Results(Completed)",
      6: "Cancelled",
    };

    const order_delivery_type = { 1: "Normal", 2: "Express" };
    //console.log(order_status_arr[1],"status");
    var c = 1;
    return (
      <div className="main-content">
        {this.state.pdfloading ? <LoadingPdfSpinner /> : ""}
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col className="fl_orderlist" md={12}>
              <Card
                tableFullWidth
                content={
                  <React.Fragment>
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          className="text-right"
                        >
                          <Button
                            className="fl_btn_add_order btn-fill"
                            class="btn-color" //bsStyle="info"
                            fill
                            onClick={this.addorder.bind(this)}
                          >
                            Add Subscription Order{" "}
                            <i className="fa fa-plus"></i>
                          </Button>
                        </Col>
                      </Col>
                    </Row>
                    <div>
                      {/* <Row >
                  <Col xs={12} sm={12} md={12} lg={12} >
                  <Col md={3} sm={4} lg={3}  xs={12} className="fl_status_dropdown" >
                  <select onChange={this.onStatusChange} name="bulkSelect" value={this.state.bulkSelect} className="form-control">
                     <option value="">Select Status</option>
                     <option value="1">Submitted</option>
                     <option value="2">Schedule Confirmed</option>
                     <option value="3">Lab Team Dispatched</option>
                     <option value="4">Sample Collected</option>
                     <option value="6">Cancelled</option>
                  </select>
                  </Col>
                  <Col md={3} sm={4} lg={3}  xs={12}>
                  <Button className="fl_btn_change_order_status btn-fill"  class="btn-color" //bsStyle="info" 
                     fill  onClick={this.handleUpdateStatus.bind(this)}>Change Order Status</Button>
                  </Col>
                  </Col>
               </Row> */}
                    </div>
                    <br />
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        {/* <Row className="OrderList_fill"  style={{ borderRadius:"5px", paddingTop:"10px", paddingBottom:"10px",  width:"98%", marginLeft:"7px"}}>
               <Row>
                  <Col md={12} sm={12} lg={12} xs={12} width>
                  <Col md={1} sm={1} lg={1}  xs={12} className="fl_mb _1"  style={{paddingLeft:"18px", width:"18%", position:"relative", right:"6px"}}  >
                  <FormControl style={{textAlign:"center"}} name="subscriber" value={this.state.subscriber ||''} placeholder="Subscriber" onChange={this.onChange} type="text" />
                  </Col>
                  <Col md={1} sm={1} lg={1} xs={12}  className="fl_mb_1" style={{paddingTop:"4px", width:"15%"}} >
                  <select name="source"  onChange={this.onChange} value={this.state.source} className="form-control" style={{textAlign:"center"}}>
                     <option  value="">Source</option>
                     <option value="1" >Flash</option>
                     <option value="2">oPharma</option>
                     <option value="3">MyPharma</option>
                  </select>
                  </Col>
                  <Col md={1} sm={1} lg={1} xs={12} className="fl_mb_1" style={{paddingTop:"4px", width:"15%"}}>
                  <select name="status" style={{textAlign:"center"}} onChange={this.onChange} value={this.state.status} className="form-control">
                     <option value="">Order Status</option>
                     <option value="1">Submitted</option>
                     <option value="10">Review</option>
                     <option value="2">Processing</option>
                     <option value="11">Packed</option>
                     <option value="3">Dispatched</option>
                     <option value="4">Completed</option>
                     <option value="5">Cancelled</option>
                     <option value="6">Attempted</option>
                     <option value="7">Unreachable</option>
                     <option value="8">Pending</option>
                     
                  </select>
                  </Col>
                  <Col md={1} sm={1} lg={1} xs={12} className="fl_mb_1" 
                  style={{paddingTop:"4px", width:"15%"}}
                  >
                  <select type="text" name="rider_id" class="form-control"  onChange={this.onChange} value={this.state.rider_id} >
                     <option value="">Select Rider</option>
                     {this.state.rider_details.map(r=>(
                     <option value={r.id}>{r.name}</option>
                     ))}
                  </select>
                  </Col>
                  <Col md={1} sm={1} lg={1} xs={12} className="fl_mb_1 fl_datepicker" 
                     style={{width:"17%"}} 
                     >
                  <Datetime
                  timeFormat={false}
                  dateFormat="YYYY-MM-DD"
                  inputProps={{ placeholder: "Order Date" }}
                  closeOnSelect={true}
                  value={this.state.orderdate}
                  onChange={this.handleDateChange}
                  />
                  </Col>
                  <Col md={1} sm={1} lg={1} xs={12} className="fl_mb_1" 
                   style={{paddingRight:"5px", marginTop:"5px"}}
                  >
                  <Button  class="btn-color"  style={{width:"100%"}}
                  
                  fill  onClick={this.searchdata.bind(this)}  >Filter</Button>&nbsp;
                  </Col>
                  <Col md={1} sm={1} lg={1} xs={12} className="fl_mb_1" 
                   style={{paddingRight:"5px",marginTop:"5px"}}
                  >
                  <Button  class="btn-color" style={{width:"100%"}}
                  fill  onClick={this.resetSearch.bind(this)} 
                  
                  >Reset</Button>
                  </Col>
                  </Col>
              </Row>
                <Row>
                    <Col md={12} sm={12} lg={12} xs={12}>
                    <Col md={3} sm={4} lg={1}  xs={12} className="fl_mb_1" style={{paddingTop:"4px", width:"18%", position:"relative"}}>
                    <select className="form-control"  placeholder="Payment" name="paymentoption" value={this.state.paymentoption}   onChange={this.onChange} >
                      <option value="">Payment type</option>
                      <option value="Cash">Cash</option>
                      <option value="Card">Card</option>
                      <option value="Cheque">Cheque</option>
                      <option value="Bank Transfer">Bank Transfer</option>
                      <option value="Hybrid">Hybrid</option>
                    </select>
                    </Col>
                    <Col md={3} sm={4} lg={1}  xs={12} className="fl_mb_1" style={{paddingTop:"4px", width:"15%"}} >
                    <select name="b2b" onChange={this.onChange} value={this.state.b2b} className="form-control">
                      <option value="">B2B Company</option>
                      {this.state.b2bDetails.map(b=>(
                      <option value={b.company_name} >{b.company_name}</option>
                      ))}
                    </select>
                    </Col>
                    <Col md={3} sm={4} lg={1}  xs={12} className="fl_mb_1" style={{paddingTop:"4px", width:"15%"}} >
                    <select name="channel_filter" onChange={this.onChange} value={this.state.channel_filter} className="form-control">
                      <option value="">Channel</option>
                      <option value="web">Web</option>
                      <option value="app">App</option>
                    </select>
                    </Col>
                    <Col md={3} sm={4} lg={1}  xs={12} className="fl_mb_1" style={{paddingTop:"0px", width:"15%"}} >
                        <input type="number" placeholder="Order Id" className="form-control" name="order_id_filter" value={this.state.order_id_filter} onChange={this.onChange} ></input>
                    </Col>
                    <Col md={1} sm={1} lg={1} xs={12} className="fl_mb_1 fl_datepicker" 
                     style={{width:"15%",paddingTop:"4px"}} 
                     >
                         <Button style={{marginTop:"3px"}}
               value="Toggle date picker"
               onClick={this.onToggle.bind(this)}
             >Date Range</Button>
         {this.state.isdaterangepickerOpen && (
                  <DateRangePicker
            value={this.state.value}
            onSelect={this.onSelect}
            singleDateRange={true}
          />
         )}
                  </Col>
                  
                    </Col>
                </Row>
            </Row>
             */}
                        <br></br>
                        <Col md={12} sm={12} lg={12} xs={12}>
                          <Table responsive>
                            <thead>
                              <tr>
                                <th>Subscriber</th>
                                <th className="text-right">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.loading ? (
                                <tr>
                                  <td colspan="10">
                                    <LoadingSpinner />
                                  </td>
                                </tr>
                              ) : this.state.noRecordFound ? (
                                <tr>
                                  <td colspan="10">
                                    <center>No record found</center>
                                  </td>
                                </tr>
                              ) : (
                                <React.Fragment>
                                  {this.state.order_chk.map(
                                    (cus) =>
                                      // <tr className={cus.is_viewed_by_admin=="0"? "red_background" : ''}>
                                      cus.lead != null && (
                                        <tr>
                                          <td>{cus.lead.name}</td>

                                          <td className="td-actions text-right no-padding">
                                            <i
                                              className="fa fa-list"
                                              onClick={this.openordermodal.bind(
                                                this,
                                                cus.lead_id
                                              )}
                                            ></i>
                                          </td>
                                        </tr>
                                      )
                                  )}
                                </React.Fragment>
                              )}
                            </tbody>
                          </Table>
                          {this.state.loading ? (
                            ""
                          ) : this.state.noRecordFound ? (
                            ""
                          ) : (
                            <div style={{ textAlign: "center" }}>
                              <Pagination>
                                {!this.state.prevdisabled ? (
                                  <Pagination.First
                                    dataUrl={this.state.prevpage}
                                    onClick={this.getdata.bind(
                                      this,
                                      this.state.prevpage
                                    )}
                                    disabled={this.state.prevdisabled}
                                  />
                                ) : (
                                  ""
                                )}
                                {this.state.paginationData.map((url) => (
                                  <Pagination.Item
                                    dataUrl={url}
                                    active={
                                      this.state.currentPage == c ? "1" : null
                                    }
                                    onClick={this.getdata.bind(this, url)}
                                  >
                                    {c++}
                                  </Pagination.Item>
                                ))}
                                {!this.state.nextdisabled ? (
                                  <Pagination.Last
                                    dataUrl={this.state.nextpage}
                                    onClick={this.getdata.bind(
                                      this,
                                      this.state.nextpage
                                    )}
                                    disabled={this.state.nextdisabled}
                                  />
                                ) : (
                                  ""
                                )}
                              </Pagination>
                            </div>
                          )}
                        </Col>
                        <Modal
                          show={this.state.showpaymentdetailmodal}
                          onHide={() =>
                            this.setState({
                              showpaymentdetailmodal: false,
                              errormessages: [],
                            })
                          }
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>Payment Details</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <form>
                              {errormessages.length != 0 && (
                                <div className=" alert alert-danger">
                                  {errormessages.map((data) => (
                                    <React.Fragment>
                                      <li>{data}</li>
                                    </React.Fragment>
                                  ))}
                                </div>
                              )}
                              <FormGroup className="order_source_data">
                                <ControlLabel>Payment type</ControlLabel>
                                &nbsp;
                                <Radio
                                  number="5"
                                  option="1"
                                  name="paymenttype"
                                  onChange={this.onpaymentchange}
                                  checked={this.state.paymenttype === "1"}
                                  label="Paid in full"
                                />
                                &nbsp;
                                <Radio
                                  number="6"
                                  option="2"
                                  name="paymenttype"
                                  onChange={this.onpaymentchange}
                                  checked={this.state.paymenttype === "2"}
                                  label="Partial Payment"
                                />
                              </FormGroup>
                              {this.state.paymenttype == "2" ? (
                                <>
                                  {this.state.p_paid_amount != null &&
                                  this.state.paymenttype == "2" ? (
                                    <p>
                                      Paid Amount :{" "}
                                      <b>
                                        {" "}
                                        {(this.state.p_paid_amount - 0).toFixed(
                                          2
                                        )}{" "}
                                      </b>{" "}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                  {this.state.remainpaymentamount != "0" &&
                                  this.state.paymenttype == "2" ? (
                                    <p>
                                      {" "}
                                      Pending Amount :{" "}
                                      <b>
                                        {" "}
                                        {(
                                          this.state.remainpaymentamount - 0
                                        ).toFixed(2)}{" "}
                                      </b>{" "}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                  {this.state.p_total_cost != "0" &&
                                  this.state.paymenttype == "2" ? (
                                    <p>
                                      {" "}
                                      Total Amount :{" "}
                                      <b>
                                        {" "}
                                        {(this.state.p_total_cost - 0).toFixed(
                                          2
                                        )}{" "}
                                      </b>{" "}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                  <FormGroup>
                                    <ControlLabel>Amount</ControlLabel>
                                    <FormControl
                                      type="number"
                                      min={0}
                                      value={this.state.paidamount}
                                      onChange={this.onpaymentchange}
                                      name="paidamount"
                                      placeholder="0.00"
                                    ></FormControl>
                                  </FormGroup>
                                </>
                              ) : (
                                ""
                              )}
                            </form>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              bsStyle="danger"
                              fill
                              onClick={this.closepaymentdetailmodal.bind(this)}
                            >
                              Close
                            </Button>
                            <Button
                              bsStyle="success"
                              fill
                              onClick={this.submitpaymentdetail.bind(this)}
                            >
                              Submit
                            </Button>
                          </Modal.Footer>
                        </Modal>
                        <Modal
                          show={this.state.cancel_reason_display_Modal}
                          onHide={() =>
                            this.setState({ cancel_reason_display_Modal: true })
                          }
                        >
                          <Modal.Header>
                            <Modal.Title>Order Cancel</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <p>
                              Cancel Reason : {this.state.Cancel_reason_state}{" "}
                            </p>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              bsStyle="danger"
                              fill
                              onClick={this.close_cancel_reason_display_Modal.bind(
                                this
                              )}
                            >
                              Cancel
                            </Button>
                          </Modal.Footer>
                        </Modal>
                        <Modal
                          show={this.state.cancelorderModal}
                          onHide={() =>
                            this.setState({ cancelorderModal: true })
                          }
                        >
                          <Modal.Header>
                            <Modal.Title>Cancel Order</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <FormGroup>
                              <ControlLabel>Cancel Order Reason</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.ordercancelreason}
                                onChange={this.oncancelchnage}
                                name="ordercancelreason"
                                placeholder="Cancel Reason"
                              ></FormControl>
                              {this.state.ordercancelreasonError}
                            </FormGroup>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              onClick={this.submitCancelOrderModal.bind(this)}
                              bsStyle="success"
                              fill
                            >
                              Submit
                            </Button>
                            &nbsp;
                            <Button
                              onClick={this.closeCancelOrderModal.bind(this)}
                              bsStyle="info"
                              fill
                            >
                              Close
                            </Button>
                          </Modal.Footer>
                        </Modal>
                        <Modal
                          bsSize="lg"
                          show={this.state.order_display_model}
                          onHide={() =>
                            this.setState({ order_display_model: true })
                          }
                        >
                          <Modal.Header>
                            <Modal.Title>Orders Details</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <Table>
                              <thead>
                                <tr>
                                  <th></th>
                                  <th>#Id</th>

                                  <th>Package</th>
                                  <th>Subscription Date</th>
                                  <th>Delivery Date</th>
                                  <th>Total Cost</th>
                                  <th>Status</th>
                                  <th>Rider Name</th>
                                  {/* <th>Pending Amount</th> */}
                                  <th>Delivery status</th>
                                  {/* 
                     <th>View Quote</th>
                     */}
                                  {/* <th>Invoice</th> */}
                                  <th className="text-right">Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.userOrderDetails.map((cus) => (
                                  <tr>
                                    <td>
                                      {cus.channel == "app" ? (
                                        <i
                                          className="fa fa-mobile"
                                          style={{ fontSize: "25px" }}
                                        ></i>
                                      ) : (
                                        ""
                                      )}
                                    </td>
                                    <td>{cus.id}</td>

                                    <td>
                                      {cus.subscriptionorder_item.length != 0
                                        ? cus.subscriptionorder_item[0].package
                                            .title
                                        : ""}
                                    </td>
                                    <td>{cus.subscription_date}</td>
                                    <td>{cus.delivery_date}</td>
                                    <td>{(cus.total_cost - 0).toFixed(2)}</td>
                                    <td>{cus.payment_status}</td>
                                    {/*
                        {cus.order_status == 1 || cus.order_status == 2 || cus.order_status == 3 || cus.order_status == 4 ? 
                           <td className="">
                              <p className="btn btn-fill fl_text_orange">{order_status_arr[cus.order_status]}</p>
                           </td>
                           : cus.order_status ==5 ? 
                           <td className="">
                              <p className="btn btn-fill fl_text_green "> {order_status_arr[cus.order_status]}</p>
                           </td>
                           : cus.order_status == 6   ? <td style={{display: 'inline-flex'}} className="">
                           <p className="btn btn-fill fl_text_red">{order_status_arr[cus.order_status]}</p>
                          
                           </td>
                           
                           : 
                           <td className="">
                              <p className="btn btn-fill">{order_status_arr[cus.order_status]}</p>
                           </td>
                           } */}

                                    <td>
                                      {cus.rider_id != null
                                        ? cus.riderdetails != null
                                          ? cus.riderdetails.name
                                          : ""
                                        : ""}
                                    </td>

                                    <td>
                                      {cus.is_delivered == 1 ? "Yes" : "No"}
                                    </td>
                                    {/* 
                        <td style={{'text-align':'center'}}>{cus.short_url == null ? '-' :<a className="btn btn-default "bsSize="xs" href={cus.short_url} target="_blank" >View</a>}</td>
                        */}
                                    {/* <td> <Button  //bsStyle="danger"
                           disabled={!this.state.processing} onClick={this.downloadinvoice.bind(this,cus.id)}  >View</Button></td> */}
                                    <td className="td-actions text-right no-padding">
                                      {/* {cus.order_status != "4" ? 
                           <OverlayTrigger placement="top" overlay={payment}>
                              <Button simple bsStyle="info" bsSize="xs" onClick={this.paymentdetail.bind(this,cus.id,cus.total_cost,cus.paid_amount)}>
                              <i class="fa fa-check-square-o"   />
                              </Button>
                           </OverlayTrigger>
                           : '' } */}
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={edit}
                                      >
                                        <Button
                                          simple
                                          bsStyle="success"
                                          onClick={this.editOrder.bind(
                                            this,
                                            cus.id,
                                            cus.channel
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-pencil" />
                                        </Button>
                                      </OverlayTrigger>
                                      {this.state.useraccess == 1 && (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={remove}
                                        >
                                          <Button
                                            simple
                                            bsStyle="danger"
                                            onClick={this.warningWithConfirmAndCancelMessage.bind(
                                              this,
                                              cus.id
                                            )}
                                            bsSize="xs"
                                          >
                                            <i className="fa fa-times" />
                                          </Button>
                                        </OverlayTrigger>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              bsStyle="danger"
                              fill
                              onClick={this.closeordermodal.bind(this)}
                            >
                              Cancel
                            </Button>
                          </Modal.Footer>
                        </Modal>
                        <Modal
                          show={this.state.ridermodel}
                          onHide={() => this.setState({ ridermodel: true })}
                        >
                          <Modal.Header>
                            <Modal.Title>Rider Details</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <FormGroup>
                              <ControlLabel>Select Rider</ControlLabel>
                              <Select
                                className="react-select primary"
                                classNamePrefix="react-select"
                                placeholder="Rider"
                                //style={{ width:"10%" }}
                                name="rider_info"
                                value={this.state.rider_info}
                                onChange={(value) =>
                                  this.setState({
                                    rider_info: value,
                                  })
                                }
                                options={this.state.rider_data}
                                // options={[
                                //   {value: '1',label : 'axay'},
                                //   {value: '2',label : 'jaimin'},
                                // ]}
                              />
                              {this.state.rider_infoError}
                            </FormGroup>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              onClick={this.submitriderdetailsModal.bind(this)}
                              bsStyle="success"
                              fill
                            >
                              Submit
                            </Button>
                            &nbsp;
                            <Button
                              onClick={this.closeriderdetailsModal.bind(this)}
                              bsStyle="info"
                              fill
                            >
                              Close
                            </Button>
                          </Modal.Footer>
                        </Modal>
                      </Col>
                    </Row>
                  </React.Fragment>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}
export default subscriptionorderlist;
